import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const user = JSON.parse(localStorage?.getItem("profile"));
const accessToken = localStorage?.getItem("accessToken");



export const logoutUser = createAsyncThunk("user/logout", async () => {
  const res = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/user/logout`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  console.log(res);
  localStorage.clear();
  return res;
});

export const userSlice = createSlice({
  name: "user",
  initialState: {
    userInfo: {
      fullname: user?.fullname || "",
      email: user?.email || "",
    },
    pending: null,
    error: false,
    errorMessage: null,
  },

  reducers: {
    updateUser: (state, action) => {
      state.userInfo.fullname = action.payload.fullname;
      state.userInfo.email = action.payload.email;
    },

    removeUser: (state) => {
      state.userInfo.fullname = null;
      state.userInfo.email = null;
    },
  },
  extraReducers: {
    [logoutUser.pending]: (state) => {
      state.pending = true;
      state.error = false;
    },
    [logoutUser.fulfilled]: (state) => {
      state.pending = false;
      state.userInfo = {};
    },
    [logoutUser.rejected]: (state) => {
      state.pending = false;
      state.error = true;
    },
  },
});

export const { updateUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
